/**
 * Web Style Import
 *
 */

import './style/dnb-radio.scss'
